/**
 * Fable Beard Co. — Shopify OS 2.0 Theme JS
 * Handles: sticky offer bar, scent filter tabs, smooth-scroll anchors.
 */

(function () {
  'use strict';

  /* ── Sticky Offer Bar ─────────────────────────────────────── */
  function initStickyBar() {
    var bar = document.querySelector('.fable-sticky-bar');
    var spacer = document.querySelector('.fable-sticky-spacer');
    if (!bar) return;

    function onScroll() {
      var visible = window.scrollY > 400;
      bar.classList.toggle('is-visible', visible);
      if (spacer) spacer.hidden = !visible;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  /* ── Scent Filter Tabs ────────────────────────────────────── */
  function initFilters() {
    var filterBtns = document.querySelectorAll('.fable-filter-btn[data-filter]');
    var productCards = document.querySelectorAll('.fable-product-card[data-category]');
    var headingEl = document.querySelector('.fable-collection__heading');
    var metaEl = document.querySelector('.fable-collection__meta');
    if (!filterBtns.length) return;

    var ALL_HEADING = headingEl ? headingEl.dataset.headingAll || 'Choose Your Adventure' : 'Choose Your Adventure';

    // Snapshot which cards are "extra" (beyond the 20-product limit) at init time.
    productCards.forEach(function (card) {
      card.dataset.isExtra = card.classList.contains('is-hidden-extra') ? '1' : '0';
    });

    // Find the section wrapper so we can check expanded state.
    var sectionWrapper = (productCards[0] && productCards[0].closest('[id^="shopify-section-"]')) || null;

    function cardCategories(card) {
      return (card.dataset.category || '').split(' ').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    function applyFilter(filter) {
      var count = 0;
      var isExpanded = sectionWrapper ? sectionWrapper.classList.contains('is-expanded') : false;

      productCards.forEach(function (card) {
        var categories = cardCategories(card);
        var categoryMatch = filter === 'all' || categories.indexOf(filter) !== -1;
        var isExtra = card.dataset.isExtra === '1';

        if (filter === 'all') {
          // Restore the original 20-product-limit visibility.
          // Extra cards are hidden unless the section is expanded.
          card.hidden = false;
          if (isExtra && !isExpanded) {
            card.classList.add('is-hidden-extra');
          } else {
            card.classList.remove('is-hidden-extra');
          }
          if (!isExtra || isExpanded) count++;
        } else {
          if (categoryMatch) {
            // Show all matching products regardless of the 20-product limit.
            card.hidden = false;
            card.classList.remove('is-hidden-extra');
            count++;
          } else {
            card.hidden = true;
            // Restore is-hidden-extra so CSS state is clean when returning to "all".
            if (isExtra) card.classList.add('is-hidden-extra');
          }
        }
      });

      filterBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.filter === filter);
      });

      // Update heading + meta text
      if (headingEl) {
        if (filter === 'all') {
          headingEl.textContent = ALL_HEADING;
        } else {
          var activeBtn = document.querySelector('.fable-filter-btn[data-filter="' + filter + '"]');
          headingEl.textContent = activeBtn ? activeBtn.dataset.label || filter : filter;
        }
      }

      if (metaEl) {
        var code   = metaEl.dataset.code        || 'FIRST';
        var prefix = metaEl.dataset.offerPrefix || '';
        var suffix = metaEl.dataset.offerSuffix || '';
        metaEl.innerHTML = prefix + ' <strong>' + code + '</strong> ' + suffix;
      }

    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.dataset.filter);
      });
    });

    // Init with "all" selected
    applyFilter('all');
  }

  /* ── Smooth Scroll Anchors ────────────────────────────────── */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-scroll-to]');
      if (!trigger) return;
      var targetId = trigger.dataset.scrollTo;
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        var stickyEls = document.querySelectorAll('[style*="position: sticky"], [style*="position:sticky"], .shopify-section-header-sticky, header');
        var navHeight = 0;
        stickyEls.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top === 0 && rect.height > 0) navHeight = Math.max(navHeight, rect.height);
        });
        var top = target.getBoundingClientRect().top + window.scrollY - navHeight - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  function boot() {
    initStickyBar();
    initFilters();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
